const safetyColors = [
  "#a72c31",
  "#f15a23",
  "#ffcb05",
  "#26b78c",
  "#31899f",
  "#238bca",
  "#1b6fb7",
  "#4170b6",
  "#435daa",
]

export default safetyColors
